import { render, staticRenderFns } from "./user-active.vue?vue&type=template&id=62f8a13b&"
import script from "./user-active.vue?vue&type=script&lang=js&"
export * from "./user-active.vue?vue&type=script&lang=js&"
import style0 from "./user-active.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports